<template>
  <div>
    <v-card class="mt-5 mb-8">
      <center>
        <vue-qrcode
          v-if="initQrCode"
          :value="qrcodeString"
          :options="{ width: 200 }"
        ></vue-qrcode>
      </center>
      <basic-user-info
        :coach-enable="true"
        :user-record="internalUserData"
      ></basic-user-info>
    </v-card>
  </div>
</template>
<script setup>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import sha512 from 'crypto-js/sha512'
import { collection, addDoc } from 'firebase/firestore'

// import { useCollection } from 'vuefire'
import moment from '@/utils/moment'
import { useStore } from '@/store'
import BasicUserInfo from '@/views/pages/components/BasicUserInfo'
import { getUserData } from '@/utils/auth'
import { getItem } from '@/api/user'

// import getDatabase from '@/firebase/index'

// const db = getDatabase()

// const coachAttendanceRef = useCollection(collection(db, 'CoachAttendance'))

const initQrCode = ref(false)

const internalUserData = ref({
  id: -1,
  fullName: '',
  gender: '',
  userNo: '',
})
const userRecord = getUserData()
const qrcodeString = ref('-1')
console.log('profile userRecord', userRecord)
function getQrcodeString() {
  console.log('internalUserDatas.value', internalUserData.value)
  console.log('internalUserData.value', internalUserData.value.id)
  const obj = {
    id: internalUserData.value.id,
    timestamp: moment().valueOf(),
    type: 'coach',
  }
  const objString = JSON.stringify(obj)
  console.log('objString', objString)
  initQrCode.value = true

  return objString
}
if (userRecord) {
  getItem(userRecord.userToken.userRecordID).then(response => {
    console.log('profile get userRecord', response)
    if (response.data.record) {
      internalUserData.value = response.data.record
      qrcodeString.value = getQrcodeString()
    }
  })
}
let interval = null

onMounted(() => {
  qrcodeString.value = getQrcodeString()

  // console.log('qrcodeString.value',qrcodeString.value)
  // refresh the qrcode every 60 seconds
  interval = setInterval(() => {
    nextTick(() => {
      qrcodeString.value = getQrcodeString()
      console.log('trigger interval', qrcodeString.value)
    })
  }, 60000)
})
onUnmounted(() => {
  console.log('onUnmounted', interval)
  clearInterval(interval)
})
</script>
<style scoped>
</style>
